module.exports = __webpack_public_path__ + "static/media/Pattern3.c27232b8.jpg";